import React, { useState } from 'react';
import { DateRangePicker } from 'react-dates';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

const DateRangePickerComponent = ({ item, onChange }) => {
	const [fromDate, setFromDate] = useState(item.value1);
	const [toDate, setToDate] = useState(item.value2);
	const [focusedInput, setFocusedInput] = useState(null);

	const saveDate = async (startDate, endDate) => {
		let from = startDate ? startDate.format('YYYY-MM-DD') : null;
		let to = endDate ? endDate.format('YYYY-MM-DD') : null;
		setFromDate(from);
		setToDate(to);
		if (startDate && endDate) {
			onChange(item.valName, item.type, item.paramName1, item.paramName2, from, to);
		}
	};
	return (
		<div className="card date-range-card">
			<div className="card-header" id={`${item.valName}_header`}>
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target={`#${item.valName}`}
						aria-expanded="false"
						aria-controls={`${item.valName}_header`}
					>
						{item.title}
					</button>
				</h5>
			</div>
			<div id={item.valName} className="collapse" aria-labelledby={`${item.valName}_header`}>
				<div className="card-body">
					<div className="pt-3 search-filter">
						<DateRangePicker
							daySize={25}
							numberOfMonths={1}
							minimumNights={0}
							displayFormat="MMM DD"
							isOutsideRange={() => false}
							startDate={fromDate ? moment(fromDate, 'YYYY-MM-DD') : null} // momentPropTypes.momentObj or null,
							startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
							endDate={toDate ? moment(toDate, 'YYYY-MM-DD') : null} // momentPropTypes.momentObj or null,
							endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
							onDatesChange={({ startDate, endDate }) => saveDate(startDate, endDate)} // PropTypes.func.isRequired,
							focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
							onFocusChange={(focusedInput) => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (store) => {
	return {
		selectedFilterItems: store.filters.selectedFilterItems
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DateRangePickerComponent);
